import React, { useEffect, useGlobal } from 'reactn'
import * as Sentry from "@sentry/gatsby"

const Logging = () => {
    const [error] = useGlobal('error')
    const [emailAddress] = useGlobal('emailAddress')
    const [fullName] = useGlobal('fullName')

    // Sentry is automatically initialized by @sentry/gatsby plugin
    // No manual init needed - it reads GATSBY_SENTRY_DSN from env vars

    useEffect(() => {
        // Set user context when available
        if ((emailAddress || fullName) && typeof window !== 'undefined') {
            Sentry.setUser({
                email: emailAddress || undefined,
                username: fullName || undefined,
            })
        }
    }, [emailAddress, fullName]);

    useEffect(() => {
        // Capture errors from global state
        if (error && typeof error === 'string' && error.length > 0 && typeof window !== 'undefined') {
            Sentry.captureException(new Error(error))
        }
    }, [error]);

    return null
}

export default Logging
